module.exports = __webpack_public_path__ + "static/media/401ErrorIcon.6dd6bbbb.png";